import React from "react";
import { Navigate } from "react-router-dom";

function OldPageRedirect({ target }) {
  return <Navigate to={target} replace />;
}

export default OldPageRedirect;
